import React from "react";
import { Link } from "react-router-dom";

import styles from "./styles.module.scss";

const DropDown = ({ handleLogout }) => {
  return (
    <ul className={styles.dropdown}>
      <Link to="/myevents">
        <li>My Events</li>
      </Link>
      <Link to="/profile">
        <li>Profile</li>
      </Link>
      <li onClick={handleLogout}>Logout</li>
    </ul>
  );
};

export default DropDown;
